<template>
  <div class="gsp-text-field-wrapper" :class="{ 'has-error': isFieldInvalid }">
    <slot name="position-start" />
    <gsp-text-field
      ref="fieldRef"
      :type="props.type"
      :value="controlValue"
      @change="onChange"
      @blur="onBlur"
      :class="{ 'gsp-text-field-error': isFieldInvalid }"
      :disabled="disabled"
      v-maska="props.maska"
      :aria-describedby="instanceId + '-textField-error'"
      :maxlength="props.maxlength"
      :minlength="props.minlength"
      :placeholder="props.placeholder"
      @keyup="onChange"
    >
      <slot />
      <gsp-text-field-error-icon slot="end" v-if="isFieldInvalid">
        <gsp-icon aria-label="Informational icon"
          >circle-info</gsp-icon
        ></gsp-text-field-error-icon
      >
    </gsp-text-field>
    <gsp-text-field-error-message
      :id="instanceId + '-textField-error'"
      aria-live="assertive"
    >
      <template v-if="isFieldInvalid">
        {{ errorMessage }}
      </template>
      <template v-else>&nbsp;</template>
    </gsp-text-field-error-message>
  </div>
</template>

<script>
let instanceCount = 0;
</script>

<script setup>
import { computed, ref } from "vue";
import initValidationField, {
  fieldProps,
  fieldEmits,
} from "~/composables/validation-field";
import { mask } from "maska";

const instanceId = `select-${instanceCount++}`;

const props = defineProps({
  ...fieldProps,
  type: {
    type: String,
    default: "text",
  },
  maska: {
    type: String,
    default: null,
  },
  maxlength: {
    type: String,
    default: null,
  },
  minlength: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
});

const fieldRef = ref(null);

const emit = defineEmits({
  ...fieldEmits,
});

const { value, isFieldInvalid, errorMessage, onBlur } = initValidationField({
  props,
  emit,
  fieldRef,
});

const controlValue = computed(() =>
  props.maska ? mask(value.value, props.maska) : value.value
);

function onChange(e) {
  value.value = props.maska ? e.target.dataset.maskRawValue : e.target.value;
}

function focus() {
  setTimeout(() => {
    fieldRef.value?.focus()
  }, 50);
}

defineExpose({ focus });
</script>
